// extracted by mini-css-extract-plugin
export default {"search_menu":"SearchMenu_search_menu__Ayuz+"};